import React from 'react';
import { Translate } from 'react-localize-redux';
import {
  ContainerMessageOtpRoot,
  MessageErrorOtp,
} from './style/OtpModalBody.style';

type ContainerMessageOtpProps = {
  externalMessage?: string;
  isError?: boolean;
};

const ContainerMessageOtp = React.memo(function ContainerMessageOtp({
  externalMessage,
  isError = true,
}: ContainerMessageOtpProps) {
  return (
    <ContainerMessageOtpRoot
      isPresentMessage={!!externalMessage}
      isError={isError}
    >
      <MessageErrorOtp id={externalMessage}>
        {externalMessage && <Translate id={externalMessage} />}
      </MessageErrorOtp>
    </ContainerMessageOtpRoot>
  );
});

export default ContainerMessageOtp;
